import React from "react"
import Page from "../../common/page/Page"
import { useAuth } from "../../data/useAuth"
import style from "./AccountPage.module.css"
import LocationIcon from "../../icons/LocationIcon"
import OrderIcon from "../../icons/OrderIcon"
import Logout from "../../icons/Logout"
import { Link } from "react-router-dom"

const AccountPage = () => {
  const { user, signOut } = useAuth()

  const getInitial = () => {
    if (!user?.first_name) return "U"
    return user.first_name.charAt(0).toUpperCase()
  }

  return (
    <Page title={"Account"} searchDisabled={true}>
      <div className={style.container}>
        {/* Profile Header Banner */}
        {user && (
          <div className={style.profileCard}>
            <div className={style.avatarCircle}>{getInitial()}</div>
            <div className={style.profileInfo}>
              <h2>
                {user.first_name} {user.last_name}
              </h2>
              <p>{user.email}</p>
            </div>
          </div>
        )}

        <h3 className={style.sectionTitle}>Account Overview</h3>

        {/* Action Dashboard Grid */}
        <div className={style.grid}>
          <Link to="/Orders" className={style.cardItem}>
            <div className={style.iconWrapper}>
              <OrderIcon />
            </div>
            <div className={style.cardContent}>
              <h4>Your Orders</h4>
              <p>Track, return or buy again</p>
            </div>
          </Link>

          <Link to="/address" className={style.cardItem}>
            <div className={style.iconWrapper}>
              <LocationIcon />
            </div>
            <div className={style.cardContent}>
              <h4>Saved Addresses</h4>
              <p>Manage delivery addresses</p>
            </div>
          </Link>

          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault()
              signOut()
            }}
            className={style.cardItem}
          >
            <div className={style.iconWrapper}>
              <Logout />
            </div>
            <div className={style.cardContent}>
              <h4>Sign Out</h4>
              <p>Securely log out of session</p>
            </div>
          </Link>
        </div>
      </div>
    </Page>
  )
}

export default AccountPage
